import React, { memo, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, useTheme } from '../../../../utils/styles';
import Icon from '../../Icon';
import Text from '../../../typography/Text';
import { downloadFile } from '@Sage/ssm-utils';

import styles from './TableWrapper.styles';

const useStyles = createUseStyles(styles, 'MarkdownTableWrapper');

const TableWrapper = memo(({ children }) => {
    const classes = useStyles();
    const theme = useTheme();
    const bodyRef = useRef(null);

    const handleDownload = useCallback(() => {
        const table = bodyRef.current?.querySelector('table');
        if (!table) return;

        const rows = Array.from(table.querySelectorAll('tr'));
        const csv = rows
            .map((row) => {
                const cells = Array.from(row.querySelectorAll('td, th'));
                return cells.map((cell) => `"${cell.textContent || ''}"`).join(',');
            })
            .join('\n');

        downloadFile(csv, 'table.csv', 'text/csv');
    }, []);

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <Text type="body" medium color={theme.colors.utility.textSecondary}>
                    Table
                </Text>
                <div className={classes.actions}>
                    <Icon className={classes.action} name="downloadAlt" onClick={handleDownload} />
                </div>
            </div>
            <div className={classes.body} ref={bodyRef}>
                {children}
            </div>
        </div>
    );
});

TableWrapper.displayName = 'MarkdownTableWrapper';

TableWrapper.propTypes = {
    /** The table element to wrap with download toolbar */
    children: PropTypes.node.isRequired,
};

export default TableWrapper;
